import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';
import {Campagne} from './campagne.model';
import {CampagneService} from './campagne.service';
import {Commission, CommissionService} from '../commission';
import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';
import {Observable, Subscription} from 'rxjs';
import {Formation, FormationService} from '../formation';
import {UserEnEchange, UserEnEchangeService} from '../user-en-echange';
import {Response} from '@angular/http';

@Component({
    selector: 'jhi-campagne-detail',
    templateUrl: './campagne-detail.component.html'
})
export class CampagneDetailComponent implements OnInit, OnDestroy {

    campagne: Campagne;
    commissions: Commission[] = [];
    formations: Formation[] = [];
    private subscription: any;
    pageEdition = 'informations';
    fr: any;
    eventCommissionSubscriber: Subscription;
    eventFormationSubscriber: Subscription;
    loading = true;
    restrictionEmailDisabled = true;
    usersAvecRestrictionEmail: UserEnEchange[];

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private campagneService: CampagneService,
        private commissionService: CommissionService,
        private formationService: FormationService,
        private userEnEchangeService: UserEnEchangeService,
        private route: ActivatedRoute,
        private eventManager: EventManager,
        private alertService: AlertService
    ) {
        this.jhiLanguageService.setLocations(['campagne', 'commission']);
        this.fr = CALENDAR_FR;
    }

    ngOnInit() {
        this.loading = true;
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.registerChangeInCommissions();
    }

    load (id) {
        this.loading = true;
        this.campagneService.find(id).subscribe(campagne => {
            this.campagne = campagne;
            let findCommissions = [];
            if (this.campagne.commissions != null && this.campagne.commissions.length > 0) {
                this.campagne.commissions.forEach(commission => {
                    findCommissions.push(this.commissionService.find(commission));
                });
                Observable.forkJoin(findCommissions).subscribe(results => {
                    this.commissions = results;
                    this.commissions.sort(function (a: Commission, b: Commission) {
                        return a.dateCommission < b.dateCommission ? -1 : 1;
                    });
                    this.loadFormations();
                });
            } else {
                this.loadFormations();
            }
        });
        this.userEnEchangeService.getRestrictionEmail(id).subscribe(
            (res: Response) => {
                this.usersAvecRestrictionEmail = res.json();
                if (this.usersAvecRestrictionEmail.length == 0) {
                    this.restrictionEmailDisabled = false;
                }
            },
            (res: Response) => this.onError(res.json())
        );
    }

    private loadFormations() {
        let findFormations = [];
        this.formationService.findFormationCampagne(this.campagne.id).subscribe(results => {
            this.formations = results;
            this.formations.sort(function(a: Formation, b: Formation) {
                return a.libelle < b.libelle ? -1 : 1;
            });
            this.loading = false;
        });
    }

    registerChangeInCommissions() {
        this.eventCommissionSubscriber = this.eventManager.subscribe('campagneCommissionsModification', (response) => {
            let comm: Commission = response.content;
            if (this.campagne.commissions == null) {
                this.campagne.commissions = [];
                this.commissions = [];
            }
            if (this.campagne.commissions.indexOf(comm.id) < 0) {
                this.campagne.commissions.push(comm.id);
            }
            if (this.commissions.indexOf(comm) < 0) {
                this.commissions.push(comm);
            }
        });
        this.eventFormationSubscriber = this.eventManager.subscribe('campagneFormationsModification', (response) => {
            let forms: Campagne[] = response.content;
            if (this.campagne.formations == null) {
                this.campagne.formations = [];
            }
            this.campagne.formations.push(...forms[0].formations);
            this.loadFormations();
        });
    }

    save() {
        if (this.commissions != null && this.commissions.length > 0) {
            this.loading = true;
            this.campagne.commissions = this.commissions.map(c => c.id);
            let updateCampagne = this.campagneService.update(this.campagne);
            let updateCommissions = this.commissionService.update(this.commissions);
            let updates = [updateCommissions, updateCampagne];
            Observable.forkJoin(updates).subscribe(results => {
                this.commissions = results[0];
                this.campagne = results[1];
                this.loading = false;
                this.alertService.success('cadensApp.campagne.updated', null, null);
            });
        } else {
            this.onError({ message: 'cadensApp.campagne.commission.required' });
        }
    }

    removeFormation(index, id) {
        // Remove the formation attached to a campagne
        this.formations.splice(index, 1);
        index = this.campagne.formations.indexOf(id);
        this.campagne.formations.splice(index, 1);
    }

    goToStep(step) {
        this.pageEdition = step;
        const element = document.querySelector('#' + step);
        if (element) {
            element.scrollIntoView(element);
        }
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventCommissionSubscriber);
        this.eventManager.destroy(this.eventFormationSubscriber);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne-detail.component.ts